"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_SIGNUP_PATH = exports.APP_EUD_URL = exports.APP_BOT_URL = exports.CUSTOMER_AREA_FAVORITES_PATH = exports.CUSTOMER_AREA_PROFILE_PATH = exports.CUSTOMER_AREA_ORDERS_PATH = exports.CUSTOMER_AREA_PATH = exports.ADMIN_PATH = exports.IMAGES_RESOURCES_PATH = void 0;
const RESOURCES_BASE_URL = 'https://meucatalogodigitalresources.grupoboticario.digital';
exports.IMAGES_RESOURCES_PATH = `${RESOURCES_BASE_URL}/customer-area/assets/images`;
exports.ADMIN_PATH = '/login';
exports.CUSTOMER_AREA_PATH = '/area-do-consumidor';
exports.CUSTOMER_AREA_ORDERS_PATH = '/area-do-consumidor/pedidos';
exports.CUSTOMER_AREA_PROFILE_PATH = '/area-do-consumidor/minha-conta';
exports.CUSTOMER_AREA_FAVORITES_PATH = '/meus-favoritos';
exports.APP_BOT_URL = {
    ios: 'https://apps.apple.com/br/app/o-botic%C3%A1rio-revendedor/id1465675800',
    android: 'https://play.google.com/store/apps/details?id=br.com.grupoboticario.boticariorepresentante&hl=pt_BR&gl=US&pli=1',
};
exports.APP_EUD_URL = {
    ios: 'https://apps.apple.com/br/app/representante-eudora/id1570275139',
    android: 'https://play.google.com/store/apps/details?id=br.com.eudora.apprepresentante&hl=pt_BR&gl=US',
};
exports.AUTH_SIGNUP_PATH = '/signup';
